import { readFile } from 'fs/promises';

import { parse as parseYAML } from 'yaml';
import { AnySchema } from 'yup';

export async function loadYamlWithSchema<TSchema extends AnySchema>(
  filePath: string,
  schema: TSchema,
): Promise<TSchema['__outputType']> {
  const fileContent = await readFile(filePath, 'utf8');

  const yamlDoc: unknown = parseYAML(fileContent);

  const result = await schema.validate(yamlDoc);
  return result;
}
